import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalBody" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "midTitle" }
const _hoisted_5 = { class: "mt-2 fs-14" }
const _hoisted_6 = { class: "list-group mt-3" }
const _hoisted_7 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_8 = { class: "list-group-item" }
const _hoisted_9 = { class: "d-flex justify-content-around align-items-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "list-group-item" }
const _hoisted_13 = { class: "modalFooter" }
const _hoisted_14 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modalHeader" }, [
      _createElementVNode("h4", null, "Account collegati")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_localized_text, {
            localizedKey: "Hai più ruoli all'interno di NutriLab?",
            text: "Hai più ruoli all'interno di NutriLab?"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "Collega i tuoi account per poter passare velocemente da un all'altro.",
            text: "Collega i tuoi account per poter passare velocemente da un all'altro."
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.$store.state.user.linkedAccounts || _ctx.$store.state.user.linkedAccounts.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nessun account collegato",
                  text: "Nessun account collegato"
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.linkedAccounts, (item, i) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, _toDisplayString(item.name), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: ($event: any) => (_ctx.switchToThis(item))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Passa a questo account",
                      text: "Passa a questo account"
                    })
                  ], 8, _hoisted_10),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: ($event: any) => (_ctx.removeThis(item))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Scollega",
                      text: "Scollega"
                    })
                  ], 8, _hoisted_11)
                ])
              ])
            ]))
          }), 256)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAccountModal && _ctx.addAccountModal(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Aggiungi account",
                text: "Aggiungi account"
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Chiudi",
            text: "Chiudi"
          })
        ])
      ])
    ])
  ]))
}